import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi } from "./api";

const Ctx = createContext({ me: null, reload: () => {} });

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(() => api("GET", "/me").then((m) => { setMe(m); setError(null); }).catch(setError), [api]);
  useEffect(() => { reload(); }, [reload]);
  return <Ctx.Provider value={{ me, error, reload }}>{children}</Ctx.Provider>;
}
export const useMe = () => useContext(Ctx);
